import React, { createContext, useContext, useState } from 'react';

const DocumentsContext = createContext();

export const DocumentsProvider = ({ children }) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [hasFetched, setHasFetched] = useState(null);
  const [documents, setDocuments] = useState([]);

  return (
    <DocumentsContext.Provider
      value={{
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        hasFetched,
        setHasFetched,
        documents,
        setDocuments,
      }}>
      {children}
    </DocumentsContext.Provider>
  );
};

export const useDocuments = () => {
  const ctx = useContext(DocumentsContext);
  if (!ctx) {
    return {
      startDate: null,
      setStartDate: () => {},
      endDate: null,
      setEndDate: () => {},
      hasFetched: null,
      setHasFetched: () => {},
      documents: [],
      setDocuments: () => {},
    };
  }
  return ctx;
};
